export default __webpack_public_path__ + "static/media/back.de7f4de3.svg";